export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
export const GIVEN_NAME = 'given_name';
export const FAMILY_NAME = 'family_name';
